import {
    Alert,
    Box,
    Chip,
    Divider,
    Grid,
    List,
    ListItem,
    ListItemText,
    Paper,
    Typography
} from '@mui/material';
import React from 'react';
import { useFormularioSecretariaMunicipalAgriculturaStore } from 'stores/forms/formularioAgricultura.store';


const INSTITUICOES = [
    { key: 'cooperativas', label: 'Cooperativas' },
    { key: 'embrapa', label: 'Embrapa' },
    { key: 'empresas_privadas', label: 'Empresas Privadas' },
    { key: 'ongs', label: 'ONGs' },
    { key: 'senar', label: 'Senar' },
    { key: 'universidades_publicas', label: 'Universidades Públicas' },
    { key: 'empaer', label: 'Empaer' },
    { key: 'ifmt', label: 'IFMT' },
    { key: 'incra', label: 'Incra' },
    { key: 'sebrae', label: 'Sebrae' },
    { key: 'universidades_privadas', label: 'Universidades Privadas' },
    { key: 'nenhuma', label: 'Nenhuma' },
];

const getInstitutionLabel = (name: string) => {
    // Remove espaços e deixa minúsculo para comparar
    const key = name.trim().toLowerCase();
    return INSTITUICOES.find(instituicao => instituicao.key === key)?.label || name;
};

const Step8View: React.FC = () => {
    const { formulario } = useFormularioSecretariaMunicipalAgriculturaStore();

    if (!formulario) {
        return (
            <Box display="flex" justifyContent="center" p={3}>
                <Typography>Carregando informações...</Typography>
            </Box>
        );
    }

    const getImportanceColor = (index: number) => {
        const colors = ['#d32f2f', '#f57c00', '#fbc02d', '#689f38', '#1976d2'];
        return colors[index] || '#757575';
    };

    const getImportanceLabel = (index: number) => {
        const labels = ['1º lugar', '2º lugar', '3º lugar', '4º lugar', '5º lugar'];
        return labels[index] || `${index + 1}º lugar`;
    };

    return (
        <Paper elevation={1} sx={{ p: 3, mt: 2 }}>
            <Typography variant="h5" gutterBottom color="primary">
                Assistência Técnica
            </Typography>

            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="body1" color="textSecondary" gutterBottom sx={{ mb: 3 }}>
                        Ordem de importância da assistência técnica prestada por outras instituições no município:
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    {formulario.ordem_importancia_assistencia_tecnica_outras_instituicoes &&
                        formulario.ordem_importancia_assistencia_tecnica_outras_instituicoes.length > 0 ? (
                        <Paper variant="outlined" sx={{ p: 3, backgroundColor: '#f8f9fa' }}>
                            <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                                Ranking de Importância
                            </Typography>

                            <List>
                                {formulario.ordem_importancia_assistencia_tecnica_outras_instituicoes.map((instituicao, index) => (
                                    <ListItem
                                        key={index}
                                        sx={{
                                            mb: 1,
                                            backgroundColor: 'white',
                                            borderRadius: 1,
                                            border: '1px solid #e0e0e0'
                                        }}
                                    >
                                        <ListItemText
                                            primary={
                                                <Box display="flex" alignItems="center" gap={2}>
                                                    <Chip
                                                        label={getImportanceLabel(index)}
                                                        sx={{
                                                            backgroundColor: getImportanceColor(index),
                                                            color: 'white',
                                                            fontWeight: 'bold'
                                                        }}
                                                        size="small"
                                                    />
                                                    <Typography variant="body1" fontWeight="500">
                                                        {getInstitutionLabel(instituicao)}
                                                    </Typography>
                                                </Box>
                                            }
                                        />
                                    </ListItem>
                                ))}
                            </List>

                            <Box sx={{ mt: 3, p: 2, backgroundColor: '#e3f2fd', borderRadius: 1 }}>
                                <Typography variant="body2" color="primary" fontWeight="bold">
                                    Total de instituições ranqueadas: {formulario.ordem_importancia_assistencia_tecnica_outras_instituicoes.length}
                                </Typography>
                            </Box>
                        </Paper>
                    ) : (
                        <Alert severity="info">
                            <Typography variant="body2">
                                Nenhuma ordem de importância da assistência técnica foi informada para este município.
                            </Typography>
                        </Alert>
                    )}
                </Grid>


            </Grid>
        </Paper>
    );
};

export default Step8View;